/**
 * Whether `pathname` is inside the nav `section`. A prefix match, so a deep page keeps its section
 * lit — `/projects/THE-COMMONS` is still "Projects". An off-by-one here means the header either never
 * lights up or lights up everywhere, and both read as broken, so it is tested directly.
 *
 * Lives here rather than in `AppHeader` because BOTH application headers need it, and the Hub
 * importing the analyzer's header module to borrow one function is the coupling that put the
 * analyzer's nav — dead links and all — on every Hub page in the first place.
 */
export function isSection(pathname: string, section: string): boolean {
  return pathname === section || pathname.startsWith(`${section}/`);
}
